import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const white = constants.colors.ui.white[500];

// Single source of truth for gradient colors
export const gradientColors = {
  position0: "#00CDF6",
  position25: "#1088EB",
  position50: "#1F3CD7",
  position100: "#691C9C",
} as const;

export const fullGradientColors = {
  position0: {
    color: gradientColors.position0,
  },
  position25: {
    color: gradientColors.position25,
  },
  position50: {
    color: gradientColors.position50,
  },
  position100: {
    color: gradientColors.position100,
  },
};

export const partialGradientColors = {
  position0: {
    color: gradientColors.position25, // Using position25 as start for partial
  },
  position25: {
    color: gradientColors.position50,
  },
  position100: {
    color: gradientColors.position100,
  },
};

// Utility function to create full gradient backgrounds with different opacity overlays
const createFullGradientBackground = (opacity: number) => {
  return `linear-gradient(to right, rgba(255, 255, 255, ${opacity}), rgba(255, 255, 255, ${opacity})), linear-gradient(97deg, ${gradientColors.position0} 0%, ${gradientColors.position25} 25%, ${gradientColors.position50} 50%, ${gradientColors.position100} 100%)`;
};

// Gradient background system matching Figma naming conventions
export const gradientBackgrounds = {
  100: createFullGradientBackground(0.9),
  200: createFullGradientBackground(0.8),
  300: createFullGradientBackground(0.7),
  400: createFullGradientBackground(0.6),
  500: createFullGradientBackground(0.5),
} as const;

export const partialLinearGradient = `linear-gradient(279deg, ${partialGradientColors.position100.color} 0%, ${partialGradientColors.position25.color} 65%, ${partialGradientColors.position0.color} 100%)`;

export const partialCtaDefaultLinearGradientBackground: CSSObject = {
  background: partialLinearGradient,
};

export const partialCtaHoverLinearGradientBackground: CSSObject = {
  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(279deg, ${partialGradientColors.position100.color} 0%, ${partialGradientColors.position25.color} 65%, ${partialGradientColors.position0.color} 100%)`,
};

export const e1Gradient = `linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), ${partialLinearGradient} border-box`;
export const gradientWithWhiteBackground =
  `linear-gradient(${white}, ${white}) padding-box, ` +
  `${partialLinearGradient} border-box`;
